__turbopack_context__.v({
  "BodyContentWrapper": "ShareModal-module-scss-module__qy2oPG__BodyContentWrapper",
  "appInput": "ShareModal-module-scss-module__qy2oPG__appInput",
  "closeIcon": "ShareModal-module-scss-module__qy2oPG__closeIcon",
  "copyLinkButton": "ShareModal-module-scss-module__qy2oPG__copyLinkButton",
  "copyLinkContainer": "ShareModal-module-scss-module__qy2oPG__copyLinkContainer",
  "facebookShare": "ShareModal-module-scss-module__qy2oPG__facebookShare",
  "input": "ShareModal-module-scss-module__qy2oPG__input",
  "inputContainer": "ShareModal-module-scss-module__qy2oPG__inputContainer",
  "inputWrapper": "ShareModal-module-scss-module__qy2oPG__inputWrapper",
  "modal-backdrop": "ShareModal-module-scss-module__qy2oPG__modal-backdrop",
  "modalBody": "ShareModal-module-scss-module__qy2oPG__modalBody",
  "modalDialog": "ShareModal-module-scss-module__qy2oPG__modalDialog",
  "modalHeader": "ShareModal-module-scss-module__qy2oPG__modalHeader",
  "sendSms": "ShareModal-module-scss-module__qy2oPG__sendSms",
  "sendSmsButton": "ShareModal-module-scss-module__qy2oPG__sendSmsButton",
  "sendSmsContainer": "ShareModal-module-scss-module__qy2oPG__sendSmsContainer",
  "sendSmsForm": "ShareModal-module-scss-module__qy2oPG__sendSmsForm",
  "show": "ShareModal-module-scss-module__qy2oPG__show",
  "socialMediaShare": "ShareModal-module-scss-module__qy2oPG__socialMediaShare",
  "socialMediaShareCol": "ShareModal-module-scss-module__qy2oPG__socialMediaShareCol",
  "socialName": "ShareModal-module-scss-module__qy2oPG__socialName",
  "socialShareContainer": "ShareModal-module-scss-module__qy2oPG__socialShareContainer",
  "url": "ShareModal-module-scss-module__qy2oPG__url",
  "whatsappShare": "ShareModal-module-scss-module__qy2oPG__whatsappShare",
});
